import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbDocument: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M16.41,1H3V23H21V5.59ZM19,21H5V3H15.59L19,6.41Z' />
          <rect x='7' y='7' width='7' height='2' />
          <rect x='7' y='10' width='10' height='2' />
          <rect x='7' y='13' width='10' height='2' />
        </g>
      </svg>
    </>
  );
};
